<!--
 @description 用户走势图
 @author xiehan
 @date 2018/12/20
-->
<template>
  <div class="userTrend__content">
    <div class="config-wrap">
      <el-popover placement="bottom-end"
        trigger="click"
        v-model="showPop">
        <el-form ref="searchForm"
          :model="searchForm"
          :inline="true">
          <el-form-item :label="$t('common.time')"
            input-width="auto">
            <el-form-item prop="startTime">
              <el-date-picker value-format="timestamp"
                style="width: 180px;"
                v-model="searchForm.startTime"
                type="datetime">
              </el-date-picker>
            </el-form-item>
            <span v-text="$t('common.to')"></span>
            <el-form-item prop="endTime"
              style="margin-left: 10px">
              <el-date-picker value-format="timestamp"
                style="width: 180px;"
                v-model="searchForm.endTime"
                type="datetime">
              </el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-button type="primary"
            @click="searchTime"
            v-g-rac="gRac('userTrend_search')"
            v-text="$t('common.search')"></el-button>
          <el-button type="primary"
            @click="autoData"
            v-text="'Auto'"></el-button>
        </el-form>
        <el-button type="text"
          @click="showPop = !showPop"
          slot="reference"
          v-text="autoText"></el-button>
      </el-popover>
      <i class="icon-shezhi config--icon ml-base"
        @click="getDeviation"
        v-g-rac="gRac('userTrend_setting')"></i>
    </div>
    <div id="dbLineChart"
      :style="chartStyle"
      class="mt-base"></div>
    <div id="kLineChart"
      :style="chartStyle"
      class="mt-base"></div>
    <el-dialog :closeOnClickModal="false"
      :title="$t('userTrend.setting')"
      :visible.sync="configVis"
      width="400px">
      <el-form ref="configForm"
        :model="configForm"
        input-width="180px"
        label-width="80px"
        :rules="configRules">
        <el-form-item :label="$t('userTrend.variation')"
          prop="variation">
          <el-input v-model.number="configForm.variation"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userTrend.deviation')"
          prop="deviation">
          <el-input v-model="configForm.deviation"
            :placeholder="$t('userTrend.deviationTips')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="configVis = false"
          v-text="$t('common.cancel')"></el-button>
        <el-button type="primary"
          @click="sendDeviation"
          v-text="$t('common.save')"></el-button>
      </span>
    </el-dialog>
    <el-dialog :closeOnClickModal="false"
      :title="barDiaTitle"
      :visible.sync="barDiaVis"
      width="600px">
      <div class="offline-sum">
        <span v-text="$t('userTrend.all') + ':'"></span>
        <span v-text="offlineSum"></span>
      </div>
      <div id="offlineChart"
        style="height: 460px; width: 552px;"></div>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="barDiaVis = false"
          v-text="$t('common.close')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 为了解决老echarts依赖太卡的问题，引入独立echarts
import rac from '@/plugins/rac-mixin'
import userTrendBiz from '@/logic/systemDiagram/userTrendBiz'
import echarts from 'echarts'
import TimeFormat from '@/utils/timeFormat'
import EventCenter from '@/utils/eventCenter'
const _echarts = require('./echarts')
const eventCenter = EventCenter()

let colors = ['#5793f3', '#d14a61']
const DOUBLE_LINE_OPTION = {
  color: colors,
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: []
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '8%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: colors[1]
        }
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        color: '#7c7c7c',
        formatter: function(value) {
          if (value.indexOf(' ') > -1) {
            let splitArr = value.split(' ')
            let str = splitArr[0] + '\n' + splitArr[1]
            return str
          }
          return value
        }
      },
      data: []
    },
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: colors[0]
        }
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        color: '#7c7c7c',
        formatter: function(value) {
          if (value.indexOf(' ') > -1) {
            let splitArr = value.split(' ')
            let str = splitArr[0] + '\n' + splitArr[1]
            return str
          }
          return value
        }
      },
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value',
      splitLine: {
        show: false
      },
      axisLine: { lineStyle: { color: '#8392A5' } },
      min: function(val) {
        let min
        if (val.min === val.max) {
          min = Math.ceil(val.min - val.max / 5)
          return min < 0 ? 0 : min
        }
        min = Math.ceil(val.min - (val.max - val.min) / 5)
        return min < 0 ? 0 : min
      },
      max: function(val) {
        if (val.min === val.max) {
          return Math.ceil(val.max / 5 + val.max)
        }
        return Math.ceil((val.max - val.min) / 5 + val.max)
      }
    }
  ],
  series: [
    {
      name: '',
      type: 'line',
      xAxisIndex: 1,
      showSymbol: false,
      hoverAnimation: false,
      data: []
    },
    {
      name: '',
      type: 'line',
      showSymbol: false,
      hoverAnimation: false,
      data: []
    }
  ]
}

const K_LINE_OPTION = {
  animation: false,
  backgroundColor: '#fff',
  legend: {
    data: ['minK', ''],
    inactiveColor: '#777',
    textStyle: {
      color: '#777'
    }
  },
  tooltip: {
    trigger: 'axis'
  },
  xAxis: {
    type: 'category',
    data: [],
    axisLine: { lineStyle: { color: '#8392A5' } }
  },
  yAxis: {
    scale: true,
    axisLine: { lineStyle: { color: '#8392A5' } },
    splitLine: { show: false }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: 40,
    containLabel: true
  },
  dataZoom: [
    {
      textStyle: {
        color: '#8392A5'
      },
      show: true,
      type: 'slider',
      bottom: 10,
      start: 0,
      end: 100
    },
    {
      type: 'inside'
    }
  ],
  series: [
    {
      type: 'candlestick',
      name: 'minK',
      data: [],
      itemStyle: {
        normal: {
          color: '#FD1050',
          color0: '#0CF49B',
          borderColor: '#FD1050',
          borderColor0: '#0CF49B'
        }
      }
    },
    {
      name: '',
      type: 'line',
      data: [],
      smooth: true,
      lineStyle: {
        normal: {
          width: 1
        }
      }
    }
  ]
}

export default {
  mixins: [rac],
  data() {
    return {
      chartInstanceDB: null,
      chartInstanceK: null,
      chartInstanceOffline: null,
      chartStyle: {
        width: '600px',
        height: '200px'
      },
      configVis: false,
      configForm: {
        variation: '',
        deviation: ''
      },
      configRules: {
        variation: [
          {
            type: 'number',
            message: `${this.$t('userTrend.variation')}${this.$t(
              'userTrend.mustInt'
            )}`
          },
          {
            required: true,
            message: `${this.$t('common.entryTips')}${this.$t(
              'userTrend.variation'
            )}`
          }
        ],
        deviation: [
          {
            required: true,
            message: `${this.$t('common.entryTips')}${this.$t(
              'userTrend.deviation'
            )}`
          }
        ]
      },
      autoText: this.$t('userTrend.auto'),
      searchForm: {
        startTime: new Date(new Date().toLocaleDateString()).getTime(),
        endTime: ''
      },
      showPop: false,
      trendTimer: null,
      trendKTimer: null,
      barDiaTitle: '',
      barDiaVis: false,
      offlineSum: 0,
      dataZoomStart: 0,
      dataZoomEnd: 100
    }
  },
  methods: {
    getKData(init = false) {
      let eventName = init ? 'getUserlData' : 'getUserlDataHideLoading'
      userTrendBiz[eventName]({
        auto: true
      }).then(data => {
        let todayTimeList = []
        let todayDataList = []
        let kDataList = []
        if (data.today && data.today.length > 0) {
          data.today.map(item => {
            todayTimeList.push(TimeFormat.getFormatTime(item.time))
            todayDataList.push(item.count)
          })
        }
        if (data.history && data.history.length > 0) {
          data.history.map(item => {
            todayTimeList.push(TimeFormat.getFormatTime(item.time))
            todayDataList.push(item.count)
          })
        }
        if (todayDataList.length > 0) {
          todayDataList.map((item, index) => {
            if (todayDataList[index] > todayDataList[index + 1]) {
              kDataList.push([
                todayDataList[index],
                todayDataList[index + 1],
                todayDataList[index + 1],
                todayDataList[index]
              ])
            } else {
              kDataList.push([
                todayDataList[index],
                todayDataList[index + 1],
                todayDataList[index],
                todayDataList[index + 1]
              ])
            }
          })
        }
        this.drawKChart(todayTimeList, kDataList, todayDataList)
        this.resize()
      })
    },
    getData(auto = true, search, init = false) {
      let searchObj = {
        auto: auto
      }
      if (!auto) {
        searchObj = { ...searchObj, ...search }
      }
      let eventName = init ? 'getUserlData' : 'getUserlDataHideLoading'
      userTrendBiz[eventName](searchObj).then(data => {
        let todayTimeList = []
        let todayDataList = []
        let yesterdayTimeList = []
        let yesterdayDataList = []
        if (data.today && data.today.length > 0) {
          data.today.map(item => {
            todayTimeList.push(TimeFormat.getFormatTime(item.time))
            todayDataList.push(item.count)
          })
        }
        if (data.yestoday && data.yestoday.length > 0) {
          data.yestoday.map(item => {
            yesterdayTimeList.push(TimeFormat.getFormatTime(item.time))
            yesterdayDataList.push(item.count)
          })
        }
        if (data.history && data.history.length > 0) {
          data.history.map(item => {
            todayTimeList.push(TimeFormat.getFormatTime(item.time))
            todayDataList.push(item.count)
          })
        }
        if (!auto) {
          this.autoText = `${TimeFormat.getFormatTime(searchObj.startTime)}
            ${this.$t('common.to')} ${TimeFormat.getFormatTime(
            searchObj.endTime
          )}`
        } else {
          this.autoText = this.$t('userTrend.auto')
        }
        this.showPop = false
        this.drawDBChart(
          todayTimeList,
          todayDataList,
          yesterdayTimeList,
          yesterdayDataList,
          auto
        )
        this.resize()
      })
    },
    drawDBChart(
      todayTimeList,
      todayDataList,
      yesterdayTimeList,
      yesterdayDataList,
      isAuto
    ) {
      DOUBLE_LINE_OPTION.legend.data = isAuto
        ? [
            this.$t('userTrend.yesterdayOnline'),
            this.$t('userTrend.todayOnline')
          ]
        : [this.$t('userTrend.onlineUser')]
      DOUBLE_LINE_OPTION.xAxis[0].data = todayTimeList
      DOUBLE_LINE_OPTION.xAxis[1].data = isAuto ? yesterdayTimeList : []
      DOUBLE_LINE_OPTION.series[0].name = isAuto
        ? this.$t('userTrend.yesterdayOnline')
        : ''
      DOUBLE_LINE_OPTION.series[1].name = isAuto
        ? this.$t('userTrend.todayOnline')
        : this.$t('userTrend.onlineUser')
      DOUBLE_LINE_OPTION.series[0].data = isAuto ? yesterdayDataList : []
      DOUBLE_LINE_OPTION.series[1].data = todayDataList
      this.chartInstanceDB.setOption(DOUBLE_LINE_OPTION)
    },
    drawKChart(todayTimeList, kData, todayData) {
      K_LINE_OPTION.xAxis.data = todayTimeList
      K_LINE_OPTION.legend.data[1] = this.$t('userTrend.todayOnline')
      K_LINE_OPTION.series[0].data = kData
      K_LINE_OPTION.series[1].name = this.$t('userTrend.todayOnline')
      K_LINE_OPTION.series[1].data = todayData
      K_LINE_OPTION.dataZoom[0].start = this.dataZoomStart
      K_LINE_OPTION.dataZoom[0].end = this.dataZoomEnd
      this.chartInstanceK.setOption(K_LINE_OPTION)
      this.chartInstanceK.on('dataZoom', params => {
        this.dataZoomStart = params.start
        this.dataZoomEnd = params.end
      })
    },
    initChart() {
      this.chartInstanceDB = echarts.init(
        document.getElementById('dbLineChart')
      )
      this.chartInstanceK = _echarts.init(document.getElementById('kLineChart'))
      this.chartInstanceK.on('click', this.chartKClick)
    },
    chartKClick(data) {
      userTrendBiz
        .getOfflineCountry({ time: TimeFormat.formatTimeTolong(data.name) })
        .then(d => {
          this.barDiaTitle = `${this.$t('userTrend.offlineUser')}-${data.name}`
          this.barDiaVis = true
          let arr = []
          let len = d.length
          let sum = 0
          for (let i = 0; i < len; i++) {
            sum += d[this.findMin(d)].count
            arr.push(d[this.findMin(d)])
            d.splice(this.findMin(d), 1)
          }
          this.offlineSum = sum
          this.$nextTick(() => {
            if (!this.chartInstanceOffline) {
              this.chartInstanceOffline = echarts.init(
                document.getElementById('offlineChart')
              )
            }
            let option = {
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top: '3%',
                containLabel: true
              },
              xAxis: {
                type: 'value',
                splitLine: { show: false }
              },
              yAxis: {
                type: 'category',
                data: arr.map(item => item.iso),
                splitLine: { show: false }
              },
              series: [
                {
                  data: arr.map(item => item.count),
                  type: 'bar'
                }
              ]
            }
            this.chartInstanceOffline.setOption(option)
          })
        })
    },
    findMin(list) {
      let num = 9999999
      let listIndex = 9999999
      list.map((item, index) => {
        if (item.count < num) {
          num = item.count
          listIndex = index
        }
      })
      return listIndex
    },
    resize() {
      if (this.chartInstanceK && !this.chartInstanceK.isDisposed()) {
        this.chartInstanceDB.resize()
        this.chartInstanceK.resize()
      }
    },
    setChartStyle() {
      const styleObj = {
        width:
          document.getElementsByClassName('tabView')[0].clientWidth - 32 + 'px',
        height:
          (document.getElementsByClassName('tabView')[0].clientHeight -
            32 -
            40) /
            2 +
          'px'
      }
      this.chartStyle = { ...styleObj }
    },
    setResize() {
      eventCenter.addResizeEvent('userTrend', () => {
        this.setChartStyle()
        this.$nextTick(() => {
          this.resize()
        })
      })
    },
    getDeviation() {
      userTrendBiz.getDeviation().then(data => {
        this.configForm.variation = data.variation
        this.configForm.deviation = data.deviation
        this.configVis = true
      })
    },
    sendDeviation() {
      this.$refs['configForm'].validate(valid => {
        if (valid) {
          userTrendBiz
            .sendDeviation({
              variation: this.configForm.variation,
              deviation: Number(this.configForm.deviation)
            })
            .then(data => {
              this.successMessage()
              this.configVis = false
            })
        } else {
          return false
        }
      })
    },
    searchTime() {
      let searchObj = { ...this.searchForm }
      if (!searchObj.endTime) searchObj.endTime = new Date().getTime()
      this.getData(false, searchObj)
      this.clearTimer()
    },
    autoData() {
      this.getData()
      this.setTimer()
    },
    clearTimer() {
      clearTimeout(this.trendTimer)
      this.trendTimer = null
    },
    setTimer() {
      this.clearTimer()
      this.trendTimer = setTimeout(() => {
        this.getData()
        this.setTimer()
      }, 60 * 1000)
    },
    clearKTimer() {
      clearTimeout(this.trendKTimer)
      this.trendKTimer = null
    },
    setKTimer() {
      this.clearKTimer()
      this.trendKTimer = setTimeout(() => {
        this.getKData()
        this.setKTimer()
      }, 60 * 1000)
    },
    successMessage() {
      this.$message({
        message: this.$t('common.success'),
        type: 'success'
      })
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'userTrend') {
        if (this.autoText === this.$t('userTrend.auto')) {
          this.autoData()
        }
        this.getKData()
        this.setKTimer()
        this.setResize()
      } else if (from.name === 'userTrend') {
        eventCenter.removeResizeEvent('userTrend')
        this.clearTimer()
        this.clearKTimer()
      }
    }
  },
  mounted() {
    this.initChart()
    this.autoData(true)
    this.getKData(true)
    this.setKTimer()
    this.setChartStyle()
    this.setResize()
  }
}
</script>

<style scoped>
.config-wrap {
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9;
}
.config--icon {
  margin-top: 4px;
  font-size: 28px;
  color: #888;
  cursor: pointer;
}
.config--icon:hover {
  color: #0b8de5;
}
.offline-sum {
  color: #000;
  font-weight: bolder;
  text-align: center;
}
</style>